import { Theme } from '@material-ui/core';
import { ThemeOptions } from '@material-ui/core/styles';

export const buttonTheme = (theme: Theme): ThemeOptions => ({
    overrides: {
        MuiButton: {
            root: {
                '& svg': {
                    marginRight: 10,
                },
                borderRadius: '60px',
                padding: theme.spacing(3, 5),
                maxHeight: 48,
            },
            disabled: {
                opacity: 0.3,
            },
            outlined: {
                padding: theme.spacing(3, 5),
            },
            containedPrimary: {
                '&.Mui-disabled': {
                    opacity: 1,
                    color: '#ffffff',
                },
            },
            containedSecondary: {
                '&.Mui-disabled': {
                    color: theme.palette.secondary.contrastText,
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            outlinedPrimary: {
                '&.Mui-disabled': {
                    color: theme.palette.text.primary,
                    borderColor: theme.palette.primary.main,
                },
            },
            outlinedSecondary: {
                color: theme.palette.text.secondary,
                '&.Mui-disabled': {
                    color: theme.palette.text.secondary,
                    borderColor: theme.palette.secondary.main,
                },
            },
        },
    },
    props: {
        MuiButton: {
            color: 'primary',
        },
    },
});
